// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"29f89e6c","63":"1c1a75d7","133":"3c254bdb","301":"61eee5fc","418":"c4c00708","444":"e8dd19a3","453":"340ff90f","682":"9dacf0d3","695":"f63e5227","735":"a2bdc33c"}[chunkId] + ".chunk.js";
};